import type * as yup from 'yup';

type Field = {
  name: string;
  label: string;
  type?: string | number;
};

// eslint-disable-next-line func-style
export function oneOfValidation<T extends yup.Schema>(
  fields: [Field, Field],
  schemaCreator: (message: string) => T
): T {
  const [fieldA, fieldB] = fields;
  const message = `Either ${fieldA.label} or ${fieldB.label} must be provided.`;

  const schema = schemaCreator(message);

  return schema.when(fieldB.name, {
    is: (val: unknown) => val === undefined,
    otherwise: () => schema.optional(),
    then: () => schema.required(message),
  }) as T;
}
